import React from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const CancelIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 20 20"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M3.99408 3.99408C4.31947 3.66868 4.84805 3.66868 5.17345 3.99408L10 8.82063L14.8266 3.99408C15.1519 3.66868 15.6805 3.66868 16.0059 3.99408C16.3313 4.31947 16.3313 4.84805 16.0059 5.17345L11.1794 10L16.0059 14.8266C16.3313 15.1519 16.3313 15.6805 16.0059 16.0059C15.6805 16.3313 15.1519 16.3313 14.8266 16.0059L10 11.1794L5.17345 16.0059C4.84805 16.3313 4.31947 16.3313 3.99408 16.0059C3.66868 15.6805 3.66868 15.1519 3.99408 14.8266L8.82063 10L3.99408 5.17345C3.66868 4.84805 3.66868 4.31947 3.99408 3.99408Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

CancelIcon.propTypes = {
  ...sizePropsTypes,
};

export default CancelIcon;
